import { style } from 'typestyle';
import { CommonStyles } from '../../common/styles/CommonStyles';

export const DropdownContainerStyleDefault = {
  ' span div div:first-child': {
    marginRight: '10px',
    height: '15px',
  },
  img: {
    padding: '0 4px 0px 0px',
  },
  'span > span:first-of-type': {
    marginTop: '1px',
  },
};

export const DropdownDefaultButton = style({
  ...DropdownContainerStyleDefault,
  $nest: {
    ...CommonStyles.Button.defaultButton,
    'div[data-portal-trap]': {
      marginTop: '4px',
    },
  },
});

export const DropdownBlueButton = style({
  ...DropdownContainerStyleDefault,
  $nest: {
    ...CommonStyles.Button.blueButton,
    'div[data-portal-trap]': {
      marginTop: '4px',
    },
  },
});

export const FilteringListClass = style({
  $nest: {
    ...CommonStyles.Button.defaultButton,
    span: {
      margin: '5px 8px',
    },
  },
});
